import { Col, DatePicker, Flex, Form, Row, Switch } from 'antd'
import complianceStyles from './compliance.less'
import React from 'react'
import dayjs from 'dayjs'
import { type ClientControlData } from '../../../../../../Types/Client/RegisteredClients/Partnership'
// import { validateDate } from '../../../../../../Utils/ValidateDate'
const ControlItems = (props: {
    clientControlViewList: ClientControlData[]
    showDatePickerMap: Record<number, boolean>
    dateValues: Record<number, dayjs.Dayjs | null>
    handleSwitchChangeControll: (
        clientControlId: number,
        checked: boolean
    ) => void
    handleDateChange: (date: dayjs.Dayjs | null, controllersId: number) => void
    openDeleteModal: (value: boolean) => void
    onbordingId: number
    servicemodelModalStatus: boolean
}): React.ReactElement => {
    const {
        clientControlViewList,
        showDatePickerMap,
        dateValues,
        handleSwitchChangeControll,
        handleDateChange,
        openDeleteModal,
        onbordingId,
        servicemodelModalStatus,
    } = props
    return (
        <>
            <Row className={complianceStyles.controlItemWidth}>
                <Col span={24}>
                    <Row className={complianceStyles.datePickerLeft}>
                        <div key={clientControlViewList[0]?.clientControlId}>
                            <Form.Item
                                name={`Controllstatus-${clientControlViewList[0]?.clientControlId}`}
                            >
                                {clientControlViewList[0]?.keyDataType ===
                                    'Bool' && (
                                    <Switch
                                        checked={
                                            showDatePickerMap[
                                                clientControlViewList[0]
                                                    ?.clientControlId
                                            ]
                                        }
                                        onChange={(checked) => {
                                            handleSwitchChangeControll(
                                                clientControlViewList[0]
                                                    ?.clientControlId,
                                                checked
                                            )
                                        }}
                                    />
                                )}
                                <span style={{ marginLeft: '10px' }}>
                                    {clientControlViewList[0]?.description}
                                </span>
                            </Form.Item>
                        </div>
                    </Row>
                    {Boolean(
                        showDatePickerMap[
                            clientControlViewList[0]?.clientControlId
                        ]
                    ) && (
                        <Row className={complianceStyles.datePickerLeft}>
                            <Col span={24}>
                                <div
                                    key={
                                        clientControlViewList[1]
                                            ?.clientControlId
                                    }
                                >
                                    <Form.Item
                                        label={
                                            clientControlViewList[1]
                                                ?.description
                                        }
                                        // rules={[
                                        //     {
                                        //         validator: async (_, value) => {
                                        //             console.log('value1', value)
                                        //             await validateDate(value)
                                        //         },
                                        //     },
                                        // ]}
                                        name={`dateValues-${clientControlViewList[1]?.clientControlId}`}
                                    >
                                        {clientControlViewList[1]
                                            ?.keyDataType === 'DateTime' && (
                                            <DatePicker
                                                value={
                                                    dateValues[
                                                        clientControlViewList[1]
                                                            ?.clientControlId
                                                    ] != null
                                                        ? dayjs(
                                                              dateValues[
                                                                  clientControlViewList[1]
                                                                      ?.clientControlId
                                                              ],
                                                              'DD/MM/YYYY'
                                                          )
                                                        : null
                                                }
                                                format="DD/MM/YYYY"
                                                allowClear
                                                className={
                                                    complianceStyles.datePicker
                                                }
                                                onChange={(
                                                    date,
                                                    dateString
                                                ): void => {
                                                    handleDateChange(
                                                        date,
                                                        clientControlViewList[1]
                                                            ?.clientControlId
                                                    )
                                                }}
                                            />
                                        )}
                                    </Form.Item>
                                </div>
                            </Col>
                        </Row>
                    )}
                    <Row className={complianceStyles.datePickerLeft}>
                        <div key={clientControlViewList[2]?.clientControlId}>
                            <Form.Item
                                name={`Controllstatus-${clientControlViewList[2]?.clientControlId}`}
                            >
                                {clientControlViewList[2]?.keyDataType ===
                                    'Bool' && (
                                    <Switch
                                        checked={
                                            showDatePickerMap[
                                                clientControlViewList[2]
                                                    ?.clientControlId
                                            ]
                                        }
                                        onChange={(checked) => {
                                            handleSwitchChangeControll(
                                                clientControlViewList[2]
                                                    ?.clientControlId,
                                                checked
                                            )
                                        }}
                                    />
                                )}
                                <span style={{ marginLeft: '10px' }}>
                                    {clientControlViewList[2]?.description}
                                </span>
                            </Form.Item>
                        </div>
                    </Row>
                    {Boolean(
                        showDatePickerMap[
                            clientControlViewList[2]?.clientControlId
                        ]
                    ) && (
                        <Row className={complianceStyles.datePickerLeft}>
                            <Col span={24}>
                                <div
                                    key={
                                        clientControlViewList[3]
                                            ?.clientControlId
                                    }
                                >
                                    <Form.Item
                                        label={
                                            clientControlViewList[3].description
                                        }
                                        // rules={[
                                        //     {
                                        //         validator: async (_, value) => {
                                        //
                                        //             await validateDate(value)
                                        //         },
                                        //     },
                                        // ]}
                                        name={`dateValues-${clientControlViewList[3]?.clientControlId}`}
                                    >
                                        {clientControlViewList[3]
                                            .keyDataType === 'DateTime' && (
                                            <DatePicker
                                                value={
                                                    dateValues[
                                                        clientControlViewList[3]
                                                            ?.clientControlId
                                                    ] != null
                                                        ? dayjs(
                                                              dateValues[
                                                                  clientControlViewList[3]
                                                                      ?.clientControlId
                                                              ],
                                                              'DD/MM/YYYY'
                                                          )
                                                        : null
                                                }
                                                format="DD/MM/YYYY"
                                                allowClear
                                                className={
                                                    complianceStyles.datePicker
                                                }
                                                onChange={(
                                                    date,
                                                    dateString
                                                ): void => {
                                                    handleDateChange(
                                                        date,
                                                        clientControlViewList[3]
                                                            ?.clientControlId
                                                    )
                                                }}
                                            />
                                        )}
                                    </Form.Item>
                                </div>
                            </Col>
                        </Row>
                    )}
                    <Row className={complianceStyles.datePickerLeft}>
                        <Col span={24}>
                            <div
                                key={clientControlViewList[4]?.clientControlId}
                            >
                                <Form.Item
                                    label={
                                        clientControlViewList[4]?.description
                                    }
                                    // rules={[
                                    //     {
                                    //         validator: async (_, value) => {
                                    //             console.log('value1', value)
                                    //             await validateDate(value)
                                    //         },
                                    //     },
                                    // ]}
                                    name={`dateValues-${clientControlViewList[4]?.clientControlId}`}
                                >
                                    {clientControlViewList[4]?.keyDataType ===
                                        'DateTime' && (
                                        <DatePicker
                                            value={
                                                dateValues[
                                                    clientControlViewList[4]
                                                        ?.clientControlId
                                                ] != null
                                                    ? dayjs(
                                                          dateValues[
                                                              clientControlViewList[4]
                                                                  ?.clientControlId
                                                          ],
                                                          'DD/MM/YYYY'
                                                      )
                                                    : null
                                            }
                                            format="DD/MM/YYYY"
                                            allowClear
                                            className={
                                                complianceStyles.datePicker
                                            }
                                            onChange={(
                                                date,
                                                dateString
                                            ): void => {
                                                handleDateChange(
                                                    date,
                                                    clientControlViewList[4]
                                                        ?.clientControlId
                                                )
                                            }}
                                        />
                                    )}
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>

                    {clientControlViewList[5]?.keyName === 'TermsSigned' && (
                        <>
                            <Form.Item
                                name={`Controllstatus-${clientControlViewList[5]?.clientControlId}`}
                            >
                                <div
                                    className={
                                        clientControlViewList[5]?.keyName ===
                                        'TermsSigned'
                                            ? complianceStyles.TermsSigine
                                            : ''
                                    }
                                >
                                    {clientControlViewList[5]?.keyDataType ===
                                        'Bool' && (
                                        <Switch
                                            disabled={onbordingId === 1}
                                            checked={
                                                showDatePickerMap[
                                                    clientControlViewList[5]
                                                        ?.clientControlId
                                                ]
                                            }
                                            onChange={(checked) => {
                                                handleSwitchChangeControll(
                                                    clientControlViewList[5]
                                                        ?.clientControlId,
                                                    checked
                                                )
                                            }}
                                        />
                                    )}
                                    <span>
                                        {clientControlViewList[5]?.description}
                                    </span>
                                </div>
                            </Form.Item>
                            <Flex justify="flex-end">
                                {showDatePickerMap[
                                    clientControlViewList[5]?.clientControlId
                                ] && (
                                    <div>
                                        {clientControlViewList[5]?.keyName ===
                                            'TermsSigned' && (
                                            <>
                                                <Switch
                                                    // disabled={onbordingId === 1}
                                                    checked={
                                                        servicemodelModalStatus
                                                    }
                                                    onChange={openDeleteModal}
                                                />{' '}
                                                Enable Service
                                            </>
                                        )}
                                    </div>
                                )}
                            </Flex>
                        </>
                    )}
                </Col>
            </Row>
        </>
    )
}

export default ControlItems
